import {enableProdMode, provideZoneChangeDetection} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

if (environment.production) {
    enableProdMode();
}

if (environment.useMock) {
    // Store MSAL Account to pass guard
    localStorage.setItem('fakeaccount', JSON.stringify({
        homeAccountId: 'fakeid',
        environment: 'login.windows.net',
        realm: '0ef544fb-3d5c-4c60-932e-735bcef00405',
        localAccountId: 'fakeid',
        username: 'fake.user@recognize.nl',
        authorityType: 'MSSTS'
    }));

    localStorage.setItem('fakeaccount-idtoken', JSON.stringify({
        homeAccountId: 'fakeid',
        environment: 'login.windows.net',
        credentialType: 'IdToken',
        realm: '0ef544fb-3d5c-4c60-932e-735bcef00405',
        clientId: 'cd4412cb-d0c7-4f7e-8861-23b8e5e01883',
        secret: 'fakeid'
    }));

    console.log('stored mock msal localstorage items');
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
    .catch(err => console.error(err));
